import { MainLayout } from "src/apps/commons/layouts";
import { FormContainers } from "src/apps/modules/remyndWarranty/";

const Page = () => <FormContainers />;
Page.Layout = MainLayout;
export default Page;
